import styled from '@emotion/styled'


export const HeaderOuter = styled.div({
  padding: '12px 20px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems : 'center',
  maxWidth: 1320,
  margin: '0 auto'
}, props => ({
}))

export const HeaderLogo = styled.div({
  width: 140
})

export const RightMenu = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems : 'center'
}, props => ({
}))

export const HeaderLabel = styled.div({
  fontWeight: 600,
  marginRight: 20,
  display: 'none',
  '@media (min-width: 768px)': {
    display: 'block'
  }
})